export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "초기화 오류",
    "StaticConfigLoader.caption.init": "초기화",
    "StaticConfigLoader.text.init": "애플리케이션 초기화 중...",
    "StaticConfigLoader.error.settings": "사이트 설정을 불러올 수 없음",
    "StaticConfigLoader.error.circuits": "서비스 구성을 불러올 수 없음",
    //app
    "Legal.Localization": "ko",
    "AchievementApp.Navbar.storeTitle": "상점",
    "AchievementApp.Navbar.supportTitle": "지원",
    "Legal.TermsConditions": "이용 약관",
    "Legal.TermsService": "서비스 약관",
    "Legal.PrivacyPolicy": "개인정보 보호정책",
    "Legal.CookiesPolicy": "쿠키 설정",
    "Legal.Copyright": "모든 상표, 로고 그리고 브랜드명은 각 소유자의 재산입니다.",
    "AchievementApp.Navbar.achievement": "개인 업적",
    "AchievementApp.Navbar.userAchievement": "사용자 업적",
    "AchievementApp.Navbar.settingsLink": "설정",
    "AchievementApp.Navbar.profileLink": "프로필",
    "AchievementApp.Navbar.reloginLink": "다시 로그인 또는 계정 변경",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net 업적",
    //commonAssets
    "ViewItemDetailed.state.completed": "완료",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "제목별로 필터링",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "네 친구",
    "UserFriendsList.heading.showMore": "더 보기",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "2단계 인증을 설정해야 합니다",
    "LimitedAccountPanel.2step.link": "2단계 인증 상세 정보",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "이메일 주소를 확인해야 합니다",
    "LimitedAccountPanel.email.link": "프로필 보기",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "계정이 다음 사유로 제한되어 있습니다:",
    "LimitedAccountPanel.conclusion": "보안 설정을 변경한 다음, 로그아웃한 후 로그인해 변경 사항을 적용해야 합니다",
    "LimitedAccountPanel.relogin": "다시 로그인할 수 있습니다",
    "EmailVerificationStateIcon.success": "이메일이 확인되어 계정이 인증되었습니다",
    "EmailVerificationStateIcon.warning": "이메일이 확인되지 않아 계정이 인증되지 않았습니다",
    "EmailVerificationStateIcon.danger": "계정이 인증되지 않았습니다. 이메일 확인이 필요합니다",
    "TwoFactorStateIcon.success": "계정이 2단계 인증으로 안전하게 보호되었습니다",
    "TwoFactorStateIcon.warning": "계정이 안전하지 않습니다. 2단계 인증이 비활성화되었습니다",
    "TwoFactorStateIcon.danger": "2단계 인증 필요",
    //userSettingsDialog
    "UserSettingDialog.saveSettings":"설정 저장",
    "UserSettingDialog.settings": "설정",
    "UserSettingDialog.userSettings": "사용자 설정",
    "UserSettingDialog.language": "언어",
    "UserSettingDialog.privacy": "친구 목록만 표시",
    "UserSettingDialog.allUsers": "모든 사용자",
    "UserSettingDialog.friendsOnly": "친구 한정",
    "UserSettingDialog.onlyMe": "나만",
    "UserSettingDialog.whoCanView": "내 업적을 볼 수 있는 사람",
    //unlockProgress
    "ViewUnlockProgress.of": " / ",
    "ViewUnlockProgress.achievCompleted": " 업적 완료",
    "ViewUnlockProgress.myUnlock": "내 업적",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "여기서 닉네임으로 검색",
    "ViewItemSearch.label.search": "사용자 검색",
    "ViewItemSearch.resultNotFound": "사용자를 찾을 수 없음",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "업적",
    "ViewItemSearch.stub.empty": "업적 없음",
    "ViewItemSearch.stub.emptyCompare_1": "사용자 ",
    "ViewItemSearch.stub.emptyCompare_2": " 업적이 이 게임에 없음",
    "ViewItemSearch.limitedAccess": "선택한 사용자의 업적은 확인이 제한되어 있습니다",
    "ViewItemSearch.heading.selectGame": "목록에서 게임 선택",
    "ViewItemSearch.globalstat.opened": "달성: ",
    "ViewItemSearch.globalstat.ofGamers": "%의 게이머",
    //authentication
    "NotAllowedMessage.caption": "허용 안 됨",
    "NotAllowedMessage.body.h1": "업적 확인",
    "NotAllowedMessage.body.h3": "현재 계정에서 허용되지 않음",
    "NotAllowedMessage.relogin": "계정 변경",
    "LandingMessage.caption": "인증",
    "LandingMessage.body": "불러오기 완료 중...",
    "TokenExpiredMessage.caption": "인증 만료됨",
    "TokenExpiredMessage.body.h3": "이와 관련해 할 수 있는 일은 별로 없지만,",
    "TokenExpiredMessage.relogin": "다시 로그인할 수 있습니다",
    "AuthErrorMessage.caption": "인증 실패",
    "AuthErrorMessage.body.h1": "인증 확인 실패",
    "AuthErrorMessage.body.code": "코드",
    "AuthErrorMessage.body.desc": "이와 관련해 할 수 있는 일은 별로 없지만,",
    "AuthErrorMessage.relogin": "다시 로그인할 수 있습니다",
    "AuthorizationRequiredMessage.caption": "인증 필요",
    "AuthorizationRequiredMessage.body.h3.1": "입장하려고 합니다:",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "하지만 더 진행하려면 승인이 필요합니다",
    "AuthorizationRequiredMessage.login": "Gaijin.Net 로그인",
    "CheckingAuthMessage.caption": "인증",
    "CheckingAuthMessage.body": "인증 확인 중. 잠시 기다려주세요",
    "AuthorizationRequiredMessageMobile.body.h3.1": "모바일 버전을 일시적으로 사용할 수 없습니다",
    "AuthorizationRequiredMessageMobile.body.h3.2": "컴퓨터 버전을 사용하세요",
    "AuthorizationRequiredMessageMobile.body.h3.3": "죄송합니다",
}